import { render, staticRenderFns } from "./CambioContrasena.vue?vue&type=template&id=208e5ee8&"
import script from "./CambioContrasena.vue?vue&type=script&lang=js&"
export * from "./CambioContrasena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports